import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=719cddb6&scoped=true"
import script from "./OurServices.vue?vue&type=script&lang=js"
export * from "./OurServices.vue?vue&type=script&lang=js"
import style0 from "./OurServices.vue?vue&type=style&index=0&id=719cddb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719cddb6",
  null
  
)

export default component.exports